import {Grid} from '@material-ui/core'
import React from 'react'
import {useContext, useRef, useState, useEffect} from 'react'
import {ReservationCalendarMainContext} from '../../context/ReservationCalendarMain'
import Day from './Day'
import Week from './Week'
import Toolbar from './Toolbar'
import './ReservationNewCalendar.scss'
import usePop from '../../utils/usePop'
import CalendarEventReservationPopup from '../CalendarEventPopup'
import CalendarEventGroupDatePopup from '../CalendarEventGroupDatePopup'
import CalendarEventDateDrivenActionPopup from '../CalendarEventDateDrivenActionPopup'
import CalendarEventActionDatePopup from '../CalendarEventActionDatePopup'
import CalendarRightSidebar from './../ReservationCalendar/CalendarRightSidebar'
import CalendarToolbar from './CalendarToolbar'
import Month from './MonthView'
import _ from 'lodash'
import useCalendarViewContext from '../../context/CalendarView'
import useCalendarEvents from './useCalendarEvents'

export default function ReservationNewCalendar() {
  const {
    selectedDate,
    calendarView,
    sidebarDateClicked,
    setSidebarDateClicked,
    realSearch,
    handleSidebarData,
  } = useContext(ReservationCalendarMainContext)
  const {viewData} = useCalendarViewContext()
  const stateCalEv = usePop()
  const {events, startDate} = useCalendarEvents()

  const eventParamsCache = useRef({
    start_date: _.cloneDeep(selectedDate).startOf(`${calendarView}`),
    end_date: _.cloneDeep(selectedDate).endOf(`${calendarView}`),
    group_field: [],
    entity_action_ids: [],
    field_filters: {},
  })

  const handleClickEvent = event => {
    stateCalEv.pop(event, {source: 'calendar'})
  }

  const handleNavigate = (e, date, events) => {
    handleSidebarData(events, date)
    setSidebarDateClicked(true)
  }

  const prepareParamsForApi = () => {
    let groups = []
    let actions = []
    let filters = {}
    let startDate = _.cloneDeep(selectedDate).startOf(`${calendarView}`)
    let endDate = _.cloneDeep(selectedDate).endOf(`${calendarView}`)
    if (!_.isEmpty(viewData.selectedView.group_view.groups)) {
      groups = viewData.selectedView.group_view.groups.map(data => {
        if (data.active === true) {
          return data
        }
        return null
      })
    }
    if (!_.isEmpty(viewData.selectedView.group_view.actions)) {
      actions = viewData.selectedView.group_view.actions.map(data => {
        if (data.active === true) {
          return data.action_id
        }
        return null
      })
    }
    if (!_.isEmpty(viewData.selectedFilteredView)) {
      viewData.selectedFilteredView.filters.map(data => {
        if (Array.isArray(data.values)) {
          filters[`${data.key}`] = data.values.map(abc => {
            return abc.id
          })
        } else {
          filters[`${data.key}`] = data.values
        }
        return filters
      })
    }
    return (eventParamsCache.current = {
      ...eventParamsCache.current,
      start_date: startDate.format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD'),
      group_field: _.compact(groups),
      entity_action_ids: _.compact(actions),
      filters: filters,
      entity_id: viewData?.selectedView?.group_view?.entity_id,
      query: realSearch,
    })
  }

  const showSidebar = sidebarDateClicked || realSearch

  return (
    <div className="ap-reservation-calendar">
      <CalendarToolbar />
      <div className="ap-reservation-calendar__container">
        {calendarView === 'day' && (
          <Day
            key={`day_${viewData.selectedView?.group_view?.entity_id}_${viewData.selectedFilteredViews?.length}_${startDate}`}
            onClickEvent={handleClickEvent}
            showSidebar={showSidebar}
            handleSidebarData={handleSidebarData}
            onNavigate={handleNavigate}
            events={events}
            selectedDate={selectedDate}
            willLoad={!_.isEmpty(viewData.selectedView)}
          />
        )}
        {calendarView === 'week' && (
          <Week
            key={`week_${viewData.selectedView?.group_view?.entity_id}_${viewData.selectedFilteredViews?.length}_${startDate}`}
            onClickEvent={handleClickEvent}
            showSidebar={showSidebar}
            handleSidebarData={handleSidebarData}
            onNavigate={handleNavigate}
            events={events}
            selectedDate={selectedDate}
            willLoad={!_.isEmpty(viewData.selectedView)}
          />
        )}
        {calendarView === 'month' && (
          <Month
            key={`month_${viewData.selectedView?.group_view?.entity_id}_${viewData.selectedFilteredViews?.length}_${startDate}`}
            onClickEvent={handleClickEvent}
            showSidebar={showSidebar}
            handleSidebarData={handleSidebarData}
            onNavigate={handleNavigate}
            events={events}
            selectedDate={selectedDate}
            willLoad={!_.isEmpty(viewData.selectedView)}
          />
        )}
        <CalendarRightSidebar
          hidden={!showSidebar}
          prepareParamsForApi={prepareParamsForApi}
          onClickEvent={handleClickEvent}
        />
      </div>
      {stateCalEv.props.data.type === 'SystemReservationAction' && (
        <CalendarEventReservationPopup {...stateCalEv.props} onClose={e => stateCalEv.close()} />
      )}
      {stateCalEv.props.data.type === 'GroupDateField' && (
        <CalendarEventGroupDatePopup {...stateCalEv.props} onClose={e => stateCalEv.close()} />
      )}
      {stateCalEv.props.data.type === 'ReservationAction' && (
        <CalendarEventDateDrivenActionPopup
          {...stateCalEv.props}
          onClose={e => stateCalEv.close()}
        />
      )}
      {(stateCalEv.props.data.type === 'ActionDateField' ||
        stateCalEv.props.data.type === 'DefaultAction') && (
        <CalendarEventActionDatePopup {...stateCalEv.props} onClose={e => stateCalEv.close()} />
      )}
    </div>
  )
}
